import React from 'react';
import { motion } from 'framer-motion';

const GameControls = ({ restartGame, gameOver, winner, isPlayerTurn }) => {
  return (
    <>
      <div style={{marginTop: "20px"}}>
        <motion.button 
          onClick={restartGame} 
          whileHover={{scale: 1.05}} 
          whileTap={{scale: 0.95}} 
          style={{
            backgroundColor: "#4CAF50",
            color: "white",
            padding: "10px 20px",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "16px",
            fontWeight: "bold"
          }}
        >
          Restart Game
        </motion.button>
      </div>
      
      <motion.p 
        style={{
          fontWeight: "bold",
          margin: "15px 0"
        }} 
        animate={gameOver ? {
          scale: [1, 1.1, 1],
          transition: {
            repeat: Infinity,
            repeatDelay: 1
          }
        } : {}}
      >
        {gameOver ?
          (winner === "Player" ? "🎉 You won! 🎉" :
            winner === "AI" ? "😞 AI won! 😞" :
              "🤝 It's a draw! 🤝") :
          (isPlayerTurn ? "Your Turn" : "AI's Turn...")}
      </motion.p>
    </>
  );
};

export default GameControls;